import { combineReducers } from "redux";
import {reducer1} from "./reducers";

export default combineReducers({
    reducer1,
})